/**
 * lib/storage.ts
 *
 * Single source of truth for all localStorage keys used by the application.
 * Import keys from here instead of defining them inline in stores or composables.
 *
 * clearUserStorage() must be called on logout to prevent data leaking across sessions.
 */

// ── Auth ─────────────────────────────────────────────────────────────────────
export const STORAGE_KEY_TOKENS = 'tokens'

// ── Query chat ───────────────────────────────────────────────────────────────
export const STORAGE_KEY_CHAT_HISTORY = 'queryChatHistory'
export const STORAGE_KEY_CHAT_CURRENT_ID = 'queryCurrentChatId'

// ── Course upload draft ───────────────────────────────────────────────────────
export const STORAGE_KEY_COURSE_DRAFT = 'course-data'

// ── Persistent filters ────────────────────────────────────────────────────────
// Keys follow the pattern: `${STORAGE_PREFIX_FILTERS}{filterKey}_{routeName}`
export const STORAGE_PREFIX_FILTERS = 'filters_'

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Remove every user-specific localStorage entry.
 * Call this on logout so that no user data persists into the next session.
 */
export function clearUserStorage(): void {
  // Named keys
  localStorage.removeItem(STORAGE_KEY_TOKENS)
  localStorage.removeItem(STORAGE_KEY_CHAT_HISTORY)
  localStorage.removeItem(STORAGE_KEY_CHAT_CURRENT_ID)
  localStorage.removeItem(STORAGE_KEY_COURSE_DRAFT)

  // Pattern-based filter keys — collect first to avoid mutating while iterating
  const filterKeys = Object.keys(localStorage).filter((k) =>
    k.startsWith(STORAGE_PREFIX_FILTERS),
  )
  filterKeys.forEach((k) => localStorage.removeItem(k))
}
